import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { frenchDate } from './frenchDate';
import { formatHourInput } from './hourInput';
import { absenceReasons } from './timesheetAbsences';
import { primeSummary } from './primeAmount';

const dateLabel = frenchDate;
export function createTimesheetPdf(sheet, { heures = [], primes = [], indemnites = [], clientComment = '', employeeComment = '', hourFormat = 'minutes' } = {}) {
  const pdf = new jsPDF();
  pdf.setFontSize(18);
  pdf.text("Relevé d'heures", 14, 20);
  let y = 28;
  const table = (head, body, options = {}) => {
    autoTable(pdf, { startY: y, margin: { top: 16, bottom: 18, left: 14, right: 14 }, theme: 'grid',
      styles: { fontSize: 10, cellPadding: 3, overflow: 'linebreak' }, headStyles: { fillColor: [30, 64, 175] },
      rowPageBreak: 'avoid', showHead: 'everyPage', head, body, ...options });
    y = pdf.lastAutoTable.finalY + 8;
  };
  table([], [
    ['Intérimaire', sheet.employeeName || '—'], ['Client', sheet.clientName || '—'],
    ['Contrat', `${sheet.contractNumber || '—'}${sheet.amendmentNumber !== '' && sheet.amendmentNumber != null ? `.${sheet.amendmentNumber}` : ''}`],
    ['Période', `${dateLabel(sheet.startDate)} au ${dateLabel(sheet.endDate)}`],
    ['Semaine', `${sheet.weekNumber || '—'}/${sheet.year || '—'}`],
    ['Chantier / Service', sheet.projectNumber || '—'], ['Fin de mission', sheet.endOfMission ? 'Oui' : 'Non'],
  ], { columnStyles: { 0: { cellWidth: 42, fontStyle: 'bold' } } });
  const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
  table([['Jour', 'Heures de jour', 'Heures de nuit', 'Motif d’absence']], days.map(day => [
    day.charAt(0).toUpperCase() + day.slice(1), formatHourInput(sheet.hours?.[day], hourFormat) || '—',
    formatHourInput(sheet.nightHours?.[day], hourFormat) || '—', absenceReasons.find(([code]) => code === sheet.absences?.[day])?.[1] || sheet.absences?.[day] || '—',
  ]));
  const total = [...Object.values(sheet.hours || {}), ...Object.values(sheet.nightHours || {})].reduce((sum, value) => sum + (Number(value) || 0), 0);
  table([['Total des heures (jour + nuit)']], [[formatHourInput(total, hourFormat)]]);
  const additional = heures.filter(row => String(row.type || '').trim() || Number(row.quantite) > 0);
  if (additional.length) table([['Heures diverses', 'Quantité']], additional.map(row => [row.type || '—', row.quantite ?? '—']));
  if (primes.length) table([['Primes', 'Montant']], primes.map(row => [row.type || '—', primeSummary(row)]));
  if (indemnites.length) table([['Indemnités non assujetties', 'Montant']], indemnites.map(row => [row.type || '—', primeSummary(row)]));
  if (clientComment) table([['Commentaire du client']], [[clientComment]]);
  if (employeeComment) table([['Commentaire de l’intérimaire']], [[employeeComment]]);
  const pages = pdf.internal.getNumberOfPages();
  for (let page = 1; page <= pages; page++) {
    pdf.setPage(page); pdf.setFontSize(9); pdf.setTextColor(100);
    pdf.text(`Page ${page}/${pages}`, 196, 289, { align: 'right' });
  }
  return pdf;
}
